var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 11.875,
    fill: "#DDE2EB",
    stroke: "#DDE2EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 11H12.3333C11.597 11 11 11.597 11 12.3333V21.6667C11 22.403 11.597 23 12.3333 23H21.6667C22.403 23 23 22.403 23 21.6667V12.3333C23 11.597 22.403 11 21.6667 11Z",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 15.667C15.2193 15.667 15.667 15.2193 15.667 14.667C15.667 14.1147 15.2193 13.667 14.667 13.667C14.1147 13.667 13.667 14.1147 13.667 14.667C13.667 15.2193 14.1147 15.667 14.667 15.667Z",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 19.0003L19.6663 15.667L12.333 23.0003",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/imageIcon.293321eb812e07ae115d98a0dae17365.svg";